import { render, staticRenderFns } from "./GoldenPandaClub.vue?vue&type=template&id=1a0376ce&scoped=true&"
import script from "./GoldenPandaClub.vue?vue&type=script&lang=js&"
export * from "./GoldenPandaClub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0376ce",
  null
  
)

export default component.exports